import React from 'react';
import { qNo } from './gachaData';

const NoteModal = ({ name, question, onClose, onRedraw, onDone }) => (
  <div
    onClick={onClose}
    className='ibg-overlay'
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(46, 43, 37, 0.45)',
      backdropFilter: 'blur(12px) saturate(120%)',
      padding: 20,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      role='dialog'
      aria-modal='true'
      style={{
        position: 'relative',
        width: 'min(480px, 92vw)',
        background: 'linear-gradient(175deg, var(--c-n-100), var(--c-n-200))',
        borderRadius: 'var(--radius-lg)',
        padding: 'clamp(30px, 6vw, 48px) clamp(24px, 5vw, 40px)',
        boxShadow: '0 34px 90px rgba(46, 43, 37, 0.4)',
        animation: 'ibgNoteIn 0.55s cubic-bezier(0.2, 1.15, 0.3, 1) both',
      }}
    >
      {/* 마스킹 테이프 */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          top: -13,
          left: '50%',
          transform: 'translateX(-50%) rotate(2deg)',
          width: 96,
          height: 28,
          borderRadius: 6,
          background: 'rgba(204, 219, 178, 0.6)',
          boxShadow: 'var(--sh-sm)',
        }}
      />
      <button
        type='button'
        onClick={onClose}
        className='ibg-close'
        aria-label='Close'
        style={{
          position: 'absolute',
          top: 14,
          right: 14,
          width: 32,
          height: 32,
          fontSize: 15,
        }}
      >
        ×
      </button>
      <div
        style={{
          textAlign: 'center',
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.26em',
          color: 'var(--c-accent-700)',
          marginBottom: 18,
        }}
      >
        NO. {qNo(question)} · FOR {name.toUpperCase()}
      </div>
      <div
        style={{
          textAlign: 'center',
          fontFamily: 'var(--f-heading)',
          fontSize: 'clamp(22px, 4.2vw, 30px)',
          lineHeight: 1.32,
          color: 'var(--c-text)',
          textWrap: 'pretty',
        }}
      >
        {question}
      </div>
      <div
        style={{
          margin: '26px auto 22px',
          width: '64%',
          borderTop: '1.5px dashed var(--c-n-400)',
        }}
      />
      <div
        style={{
          display: 'flex',
          gap: 12,
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <button
          type='button'
          onClick={onRedraw}
          className='ibg-btn-outline'
          style={{ fontSize: 14, padding: '13px 24px' }}
        >
          Draw another
        </button>
        <button
          type='button'
          onClick={onDone}
          className='ibg-btn-primary'
          style={{ fontSize: 14, padding: '13px 28px' }}
        >
          I've answered
        </button>
      </div>
    </div>
  </div>
);

export default NoteModal;
